'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _UserAccount = require('./UserAccount.scss');

var _UserAccount2 = _interopRequireDefault(_UserAccount);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ClickTracker = require('../../services/ClickTracker');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAccount = function (_React$Component) {
  (0, _inherits3.default)(UserAccount, _React$Component);

  function UserAccount(props) {
    (0, _classCallCheck3.default)(this, UserAccount);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserAccount.__proto__ || (0, _getPrototypeOf2.default)(UserAccount)).call(this, props));

    _this.onClick = function () {
      (0, _ClickTracker.addClickTrack)(_this.automationName);

      _this.setState({
        showMenu: true
      });
    };

    _this.onBlur = function () {
      _this.setState({
        showMenu: false
      });
    };

    _this.onMenuItemClick = function (id) {
      (0, _ClickTracker.addClickTrack)(_this.automationName + '_item_' + id);

      _this.onBlur();
      _this.props.onMenuItemClick(id);
    };

    _this.automationName = 'navmenu_user_account';

    _this.state = {
      showMenu: false
    };
    return _this;
  }

  (0, _createClass3.default)(UserAccount, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { 'data-cwid': this.automationName, className: (0, _classnames2.default)(this.props.className, _UserAccount2.default.wrap), onBlur: this.onBlur, tabIndex: -1 },
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('CwThemeBackgroundColor', _UserAccount2.default.initials), onClick: this.onClick },
          this.props.initials
        ),
        this.state.showMenu ? _react2.default.createElement(
          'div',
          { className: _UserAccount2.default.menu },
          this.props.items.map(function (item) {
            return _react2.default.createElement(
              'div',
              { key: item.id, className: _UserAccount2.default.menuItem, onClick: function onClick() {
                  return _this2.onMenuItemClick(item.id);
                } },
              item.name
            );
          })
        ) : null
      );
    }
  }]);
  return UserAccount;
}(_react2.default.Component);
//@ts-ignore


;

UserAccount.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string
  })).isRequired,
  initials: _propTypes2.default.string,
  onMenuItemClick: _propTypes2.default.func,
  className: _propTypes2.default.string
};

exports.default = UserAccount;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/navigation/UserAccount.js
// module id = 750
// module chunks = 10